export default "__VITE_ASSET__b238f1af__"